/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextInput = _interopRequireDefault(require("../../../../packages/TextInput"));
var _autoBind = _interopRequireDefault(require("../../../../packages/react-class/autoBind"));
var _reactCleanProps = _interopRequireDefault(require("../../../../packages/react-clean-props"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var InovuaTextEditor = function (_React$Component) {
  (0, _inherits2.default)(InovuaTextEditor, _React$Component);
  var _super = _createSuper(InovuaTextEditor);
  function InovuaTextEditor(props) {
    var _this;
    (0, _classCallCheck2.default)(this, InovuaTextEditor);
    _this = _super.call(this, props);
    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(InovuaTextEditor, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var value = props.value;
      var domProps = (0, _reactCleanProps.default)(props, InovuaTextEditor.propTypes);
      var className = 'InovuaReactDataGrid__cell__editor InovuaReactDataGrid__cell__editor--text ' + (domProps.className || '');
      return _react.default.createElement(_TextInput.default, _objectSpread(_objectSpread({
        autoFocus: props.autoFocus,
        value: value,
        theme: props.theme,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        enableClearButton: true
      }, domProps), {}, {
        className: className
      }));
    }
  }, {
    key: "onChange",
    value: function onChange(value, e) {
      var onChange = this.props.onChange;
      if (onChange) {
        onChange(value, e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      if (this.props.onComplete) {
        this.props.onComplete(e);
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (e.key === 'Enter') {
        if (this.props.onComplete) {
          this.props.onEnterNavigation(true, e.shiftKey ? -1 : 1, e);
        }
      }
      if (e.key === 'Escape') {
        if (this.props.onCancel) {
          this.props.onCancel(e);
        }
      }
      if (e.key == 'Tab') {
        e.preventDefault();
        this.props.onTabNavigation(true, e.shiftKey ? -1 : 1, e);
      }
    }
  }]);
  return InovuaTextEditor;
}(_react.default.Component);
InovuaTextEditor.propTypes = {
  onCancel: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onComplete: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onTabNavigation: _propTypes.default.func,
  gotoNext: _propTypes.default.func,
  gotoPrev: _propTypes.default.func,
  value: _propTypes.default.any,
  cell: _propTypes.default.any,
  cellProps: _propTypes.default.any,
  nativeScroll: _propTypes.default.any,
  editorProps: _propTypes.default.any,
  onEnterNavigation: _propTypes.default.func
};
var _default = InovuaTextEditor;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/Cell/editors/Text.js
// module id = 546
// module chunks = 0